import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rh',
  standalone: true,
})
export class RhPipe implements PipeTransform {
  transform(input: number): any {
    if (!input) {
      return '--';
    }
    if (Number.isInteger(input)) {
      return input;
    } else {
      return input.toFixed(1);
    }
  }
}
